(() => {
  if (!location.pathname.includes('/apps/wishlist') && !document.querySelector('wishlist-page')) return;
  const responses = new Map();
  const enhanced = new WeakMap();
  let sequence = 0;
  let activeRequests = 0;
  const requestQueue = [];
  function requestCard(url) {
    return new Promise((resolve, reject) => {
      requestQueue.push({ url, resolve, reject });
      drainRequests();
    });
  }
  function drainRequests() {
    while (activeRequests < 4 && requestQueue.length) {
      const job = requestQueue.shift();
      activeRequests++;
      fetch(job.url, { credentials: 'same-origin' }).then(async (response) => {
        if (!response.ok) throw new Error('Wishlist product unavailable');
        return response.text();
      }).then(job.resolve, job.reject).finally(() => { activeRequests--; drainRequests(); });
    }
  }

  function cardMarkup(href) {
    const url = new URL(href, location.origin);
    if (url.origin !== location.origin || !url.pathname.includes('/products/')) return Promise.reject(new Error('Invalid wishlist product'));
    url.search = '';
    url.searchParams.set('section_id', 'mainrose-card-product');
    const key = url.href;
    if (!responses.has(key)) {
      responses.set(key, requestCard(key).then((html) => {
        const card = new DOMParser().parseFromString(html, 'text/html').querySelector('product-card');
        if (!card) throw new Error('Missing wishlist product card');
        return card.outerHTML;
      }).catch((error) => { responses.delete(key); throw error; }));
    }
    return responses.get(key);
  }

  function uniqueIds(card) {
    const prefix = `mr-wishlist-${++sequence}`;
    const ids = new Map();
    card.dataset.mrCardUid = prefix;
    card.querySelectorAll('[id]').forEach((element) => {
      const old = element.getAttribute('id');
      const next = `${prefix}-${old}`;
      ids.set(old, next);
      element.setAttribute('id', next);
    });
    card.querySelectorAll('*').forEach((element) => {
      ['for', 'form', 'aria-controls', 'aria-labelledby', 'aria-describedby', 'observe-form', 'form-id'].forEach((attribute) => {
        const value = element.getAttribute(attribute);
        if (value) element.setAttribute(attribute, value.split(' ').map((id) => ids.get(id) || id).join(' '));
      });
      if (element.matches('input[type="radio"]')) element.name = `${prefix}-${element.name}`;
    });
  }

  function addRemoveControl(host) {
    const figure = host.querySelector('.mr-wishlist-card .product-card__figure');
    if (!figure || figure.querySelector('.mr-wishlist-remove')) return;
    // Delegate to Swish's existing Remove control, so shared/owned lists keep their native behavior.
    if (!host.querySelector('.wk-product-card remove-button button')) return;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'mr-wishlist-remove';
    button.setAttribute('aria-label', 'Remove from Wishlist');
    button.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8l1.1 1.1L12 21l7.8-7.5 1.1-1.1a5.5 5.5 0 0 0-.1-7.8Z" fill="currentColor" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    figure.append(button);
  }

  async function enhance(host) {
    const link = host.querySelector('.wk-product-card .wk-image-link');
    if (!link) return;
    const key = `${host.dataset.wishlistItemId}:${link.getAttribute('href')}`;
    if (enhanced.get(host) === key) { addRemoveControl(host); return; }
    enhanced.set(host, key);
    try {
      const markup = await cardMarkup(link.href);
      if (!host.isConnected || enhanced.get(host) !== key) return;
      const card = new DOMParser().parseFromString(markup, 'text/html').querySelector('product-card');
      uniqueIds(card);
      if (host === host.parentElement.firstElementChild) card.querySelector('mr-card-gallery')?.setAttribute('data-swipe-hint', '');
      const wrapper = document.createElement('div');
      wrapper.className = 'mr-wishlist-card';
      wrapper.append(document.importNode(card, true));
      host.querySelector(':scope > .mr-wishlist-card')?.remove();
      host.append(wrapper);
      host.setAttribute('data-mr-wishlist-native', '');
      addRemoveControl(host);
    } catch (error) {
      // The original app card stays visible and functional if Shopify cannot render it.
      console.warn('Main Rose wishlist: using original product card.', error);
    }
  }

  function setup(page) {
    if (page.dataset.mrWishlistReady) return;
    page.dataset.mrWishlistReady = 'true';
    const scan = () => page.querySelectorAll('wishlist-product-card').forEach(enhance);
    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; scan(); });
    });
    observer.observe(page, { childList: true, subtree: true });
    page.addEventListener('click', (event) => {
      const button = event.target.closest?.('.mr-wishlist-remove');
      if (!button) return;
      event.preventDefault();
      const host = button.closest('wishlist-product-card');
      host?.querySelector('.wk-product-card remove-button button')?.click();
    });
    scan();
  }

  const start = () => {
    const pages = document.querySelectorAll('wishlist-page');
    pages.forEach(setup);
    return pages.length > 0;
  };
  // App embeds can mount after the theme's deferred scripts have run.
  if (!start()) {
    const mountObserver = new MutationObserver(() => { if (start()) mountObserver.disconnect(); });
    mountObserver.observe(document.getElementById('main') || document.body, { childList: true, subtree: true });
  }
})();
